import { render, staticRenderFns } from "./AnswerChoicesHorizontal.vue?vue&type=template&id=4fc49b14&scoped=true&"
import script from "./AnswerChoicesHorizontal.vue?vue&type=script&lang=js&"
export * from "./AnswerChoicesHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./AnswerChoicesHorizontal.vue?vue&type=style&index=0&id=4fc49b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc49b14",
  null
  
)

export default component.exports